import {IStringTree} from '@entities/common/interfaces';

export function mapObject<K, R, T extends IStringTree<K>>(
  obj: T,
  fn: (val: IStringTree<K>) => R
): IStringTree<R> {
  return Object.keys(obj).reduce((acc, key) => {
    acc[key] = fn(obj[key] as IStringTree<K>);
    return acc;
  }, {} as IStringTree<R>);
}
